import ReactPlayer from 'react-player';
import styled from '@emotion/styled';
import { Component as ComponentContainer } from '@styles/layout';
import { GenericComponent } from '@model/content';
import { aspectRatioPaddings, AspectRatios } from '@model/common/image';
import { withIsServer } from '@components/hoc';

const Container = styled(ComponentContainer)(({ theme }) => ({
  padding: `${theme.custom.spacing.large}px 0`
}));

const VideoPlayerWrapper = styled.div(({ theme }) => ({
  background: theme.custom.colors.black,
  margin: `0 ${theme.custom.spacing.large}px`,
  position: 'relative',
  paddingTop: aspectRatioPaddings[AspectRatios['16:9']]
}));

interface VideoContainerProps extends GenericComponent {
  isServer: boolean;
}

export const VideoContainer = withIsServer(({ value, isServer }: VideoContainerProps) => {
  if (isServer) return null;

  return (
    <Container>
      <VideoPlayerWrapper>
        <ReactPlayer
          url={value}
          controls={true}
          width={'100%'}
          height={'100%'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0
          }}
        />
      </VideoPlayerWrapper>
    </Container>
  );
});
